

import { X } from "lucide-react";

interface ImageViewerProps {
  imageUrl: string;
  title: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function ImageViewer({ imageUrl, title, isOpen, onClose }: ImageViewerProps) {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4" 
      onClick={onClose}
    >
      <div className="relative max-w-5xl max-h-[90vh] w-full" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 text-white hover:text-stone-300 transition-colors p-2"
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Image Container */}
        <div className="bg-white rounded-xl overflow-hidden shadow-2xl">
          {/* Header */}
          <div className="px-4 py-3 border-b border-stone-200 bg-stone-50">
            <h3 className="font-semibold text-stone-800">{title}</h3>
          </div>
          
          {/* Image */}
          <div className="flex items-center justify-center bg-stone-100 p-4">
            <img 
              src={imageUrl} 
              alt={title} 
              className="max-w-full max-h-[70vh] object-contain rounded-lg" 
            />
          </div>
        </div>
      </div>
    </div>
  );
}
